import React, { useContext, useState } from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';

import RouterLink from './RouterLink';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import ISave from 'icons/ISave';
import { AuthContext } from './Auth/Auth';
import { Input, notification } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import {
  ParPagComponentRequest,
  updatePageComponent,
} from 'services/displayFramework';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';

export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
  custom?: any;
  Inspectstyle?: React.CSSProperties;
  type?: string;
};

const UpdateButton = ({
  comcode,
  custom,
  Inspectstyle,
  type,
  ...otherProps
}: ButtonProps) => {
  const { isHidden, label, style } = useComponentConfiguration(comcode);
  const { isInspect } = useContext(AuthContext);
  const [newLabel, setNewLabel] = useState('');
  const { pagcode, refresh } = useDisplayFrameworkContext();

  if (isHidden) {
    return null;
  }
  const handleSaveNewLabel = (comcode: string, labelp: string) => {
    const request: ParPagComponentRequest = {
      comcode: comcode ?? '',
      comformat: '',
      comhint: '',
      comlabel: newLabel === '' ? label : labelp,
      commessage: '',
      complaceholder: '',
      comrequired: false,
      comstyle: '',
      comtype: '',
      pagcode: pagcode ?? '',
    };
    updatePageComponent({ request: request }).then((res) => {
      if (res.code === '200')
        notification.success({
          message: res.message,
          description: res.description,
        });
      else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
      refresh();
    });
  };
  const props = {
    ...otherProps,
    children: isInspect ? (
      <Input
        defaultValue={label === '' ? comcode : label}
        size="middle"
        onChange={(event) => {
          event.preventDefault();
          setNewLabel(event.target.value);
        }}
        onClick={(event) => {
          event.preventDefault();
        }}
        style={Inspectstyle ?? { width: '50%' }}
        className="input-inspect"
        addonAfter={
          <SaveOutlined
            onClick={(ev) => {
              ev.preventDefault();
              handleSaveNewLabel(comcode, newLabel);
            }}
          />
        }
      />
    ) : (
      label
    ),
    style,
  };

  if (props.to) {
    return <RouterLink component={AntButton} {...props} />;
  } else {
    return (
      <AntButton
        htmlType={isInspect ? 'button' : 'submit'}
        {...props}
        style={custom}
        icon={<ISave color="white" />}
        type={type ? type : 'primary'}
      />
    );
  }
};

export default UpdateButton;
